const tabValue = new Map([
  ["0", "all"],
  ["1", "facebook"],
  ["2", "whatsapp"],
  ["3", "instagram"],
  ["4", "facebook_comments"],
  ["5", "chatbot"],
]);

const useSource = (val: number) => {
  return tabValue.get(String(val));
};

export default useSource;
